seedWebApp.controller('IntegrationAppCtrl', ['$scope', '$uibModal', '$location', 'IntegrationAppService', 'ToastService', '$timeout', '$rootScope', 'TranslationService',
    function ($scope, $uibModal, $location, IntegrationAppService, ToastService, $timeout, $rootScope, TranslationService) {

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.loading = false;
        $scope.logger = [];
        $scope.logMsg = 'Nenhuma integração';
        $scope.log = {
            Msg: 'Nenhuma integração',
            NumErrors: 0,
            NumInfos: 0
        };

        $scope.integrationAppConfig = {
            IntegrationAppConfigID: '',
            JsonConfig: 'Aguarde, carregando...'
        };
        
        $scope.loadConfig = function () {
            $scope.error = false;
            $scope.loading = true;
            IntegrationAppService.get({}, function (data) {
                console.log('configJson');                
                if (data) {

                    $scope.configJson = data.JsonConfig;
                    //console.log('[' + $scope.configJson + ']');
                }
                //else {
                //    $scope.integrationAppConfig = IntegrationAppService.appConfigModel;
                //}
                $scope.loading = false;
            }, function (errorDescription) {
                $scope.loading = false;
                $scope.error = true;
                $scope.errorDescription = errorDescription;
            });
        };

        $scope.loadQueue = function () {
            $scope.error = false;
            $scope.loading = true;
            IntegrationAppService.getQueue().then(function (result) {
                //console.log('loadQueue');
                //console.log(result);

                if (result) {
                    $scope.messages = result.data;                    
                }
                $scope.loading = false;
            }, function (error) {
                console.log(error);
            });
        };

        $scope.loadIntegrs = function () {
            $scope.error = false;
            $scope.loading = true;
            IntegrationAppService.getIntegrTables().then(function (result) {
                //console.log('loadQueue');
                //console.log(result);
                if (result) {
                    $scope.integrs = result.data;
                    $scope.logMsg = $scope.integrs.length + ' integrações';
                }
                $scope.loading = false;
            }, function (error) {
                console.log(error);
            });
        };

        //$scope.loadSyncs = function () {
        //    IntegrationAppService.getIntegrSyncs().then(function (result) {
        //        if (result) {
        //            $scope.syncs = result.data;                   
        //        }
        //    }, function (error) {
        //        console.log(error);
        //    });
        //};

        $scope.loadConfig();
        $scope.loadQueue();
        $scope.loadIntegrs();
        //$scope.loadSyncs();


        $scope.refreshConfig = function () {
            IntegrationAppService.resetCache();
            $scope.loadConfig();
            $scope.loadIntegrs();
            $scope.loadQueue();
        };


        $scope.showConfig = function () {
            //if (!$scope.isIntegrationAppOnline) {
            //    //canQueueIntegrationRun = confirm('O aplicativo integrador parece estar offline. Deseja mesmo forçar uma integração?');
            //}
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/IntegrationAppConfig/editIntegrationAppConfig.html',
                controller: 'EditIntegrationAppConfigCtrl',
                size: 'lg',
                resolve: {
                    //integrationID: function () { return integrationID; }
                }
            });
            modalInstance.result.then(function () {
                ToastService.createToast('Configuração atualizada com sucesso!', '', 4000, 'success');
            });
        };


        $scope.showToken = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/editToken.html',
                controller: 'EditTokenCtrl',
                size: 'lg',
                resolve: {
                    //integrationID: function () { return integrationID; }
                }
            });
            modalInstance.result.then(function () {
                ToastService.createToast('Token atualizado!', '', 4000, 'success');
            });
        };

        $scope.updateStatus = function (tables) {
            //console.log('updateLastStatus');
            $scope.integrs = tables;
        };

        $scope.toggleOption = function (item, optionName) {           
            item[optionName] = !item[optionName];
        };

        $scope.updateProgress = function (status) {
            for (var i = 0; i < $scope.integrs.length; i++) {
                var int = $scope.integrs[i];
                if (int.ExecMarka || int.ExecIntegration) {
                    int.StatusID = status;
                    int.StatusMsg = '';
                }
            }
        };

        $scope.decodeLogger = function (logger) {
            console.log('decodeLogger');

            $scope.logMsg = 'Num logs: ' + $scope.logger.length;
            $scope.log.NumErrors = 0;
            $scope.log.NumInfos = 0;
            logger.forEach(function (item) {
                if (item.MsgType == 'Error') {
                    $scope.log.NumErrors++;
                }
                if (item.MsgType == 'Information') {
                    $scope.log.NumInfos++;
                }
            })
            $scope.logMsg = 'Num erros: ' + $scope.log.NumErrors;
            $scope.logMsg += ', ';
            $scope.logMsg += 'Num infos: ' + $scope.log.NumInfos;
        };

        $scope.execSelected = function () {
            console.log('execSelected');
            $scope.logMsg = 'Executing...';
            var toastID = ToastService.createToast('Executando selecionados', '', 4000, 'wait');
            var numSelected = 0;
            $scope.integrs.forEach(function (item) {
                if (item.ExecMarka || item.ExecIntegration) {
                    numSelected++;
                    item.StatusID = 'Executing';
                    item.StatusMsg = '';
                    IntegrationAppService.execIntegr(item).then(
                        function (result) {
                            item.StatusID = result.data.StatusID;
                            item.StatusMsg = result.data.StatusMsg;
                            //ToastService.updateToast(toastID, 'Salvo!', integr.Name, 2000, 'success');
                        },
                        function (error) {
                            console.log(error);
                            ToastService.updateToast(toastID, 'Erro executar!', '', 2000, 'error');
                        }
                    );
                }
            });
            $scope.logMsg = 'Executando ' + numSelected + ' integrações';
        };

        $scope.queueImport = function () {
            //console.log('queueImport');
            $scope.updateProgress('Executing');
            $scope.logMsg = 'Executing...';
            var toastID = ToastService.createToast('Adicionando na fila!', '', 4000, 'wait');
            IntegrationAppService.queueImport().then(
                function (result) {
                    $scope.loading = false;
                    $scope.error = false;
                    //console.log('queue ADDED!');

                    $scope.logger = result.data.Logger;
                    $scope.updateStatus (result.data.Tables);
                    $scope.decodeLogger($scope.logger);
                    

                    //$scope.logger = $scope.logger.concat(result.data.Items);
                    ToastService.createToast('Executado!', '', 4000, 'success');
                    //$scope.listItem = result.data;
                    //console.log($scope.listItem);
                    //$scope.decodeSettings();
                    //$scope.checkModuleActiveToSelectHomePage();
                },
                function error(error) {
                    $scope.loading = false;
                    //$scope.error = true;
                    //$scope.errorDescription = errorDescription;
                    console.log(error);
                    var msg = '';
                    if (error.data) {
                        msg = error.data.Message;
                        if (error.data.ExceptionMessage) {
                            if (msg) {
                                msg += ', ';
                            }
                            msg += error.data.ExceptionMessage;
                        }
                    }
                    $scope.logMsg = msg;
                    ToastService.createToast('Erro ao adicionar na fila', msg, 4000, 'error');
                });

        };

        $scope.saveChange = function (integr) {            
            $timeout(function () {
                //console.log('saveChange');
                //console.log(integr);
                var toastID = ToastService.createToast('Salvando alteração', integr.Name, 4000, 'wait');
                IntegrationAppService.saveIntegrTable(integr).then(
                    function () {
                        ToastService.updateToast(toastID, 'Salvo!', integr.Name, 2000, 'success');
                    },
                    function (error) {
                        console.log(error);
                        ToastService.updateToast(toastID, 'Erro salvar!', '', 2000, 'error');
                    }
                );
            }, 1000);            
        };

        $scope.closeLogs = function () {
            $scope.logMsg = null;
        };

        $scope.showModalLog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/integrationLogModal.html',
                controller: 'IntegrationLogModalCtrl',
                size: 'lg',
                resolve: {
                    translation: function () { return $scope.translation; },
                    logMsg: function () { return $scope.logMsg; },
                    logger: function () { return $scope.logger; }
                }
            });           
        };

    }
]);